import { WeatherReports } from "@planzone/dto";

type ZoneIndicators = {
  name: string;
  color: string;
  description: string;
  savingTemplates: boolean;
  weather: WeatherReports;
  averageOfConsistencyOfStrategicAxes: number;
  finalPlannedValueOfProject: number;
  proportionOfAccomplishedWork: number;
  proportionOfDelayedWork: number;
  proportionOfOpenedWork: number;
  totalOfRemainingTimeInProject: number;
  totalOfTimesSpentInProject: number;
  totalSumOfTimeAllocatedOnTheProject: number;
  trackingAcquiredValue: number;
  trackingRealCost: number;
  totalNumberOfProjectsInZone: number;
};

const zoneIndicators: ZoneIndicators = {
  name: "",
  color: "",
  description: "",
  savingTemplates: false,
  weather: WeatherReports.SUNNY,
  averageOfConsistencyOfStrategicAxes: 0,
  finalPlannedValueOfProject: 0,
  proportionOfAccomplishedWork: 0,
  proportionOfDelayedWork: 0,
  proportionOfOpenedWork: 0,
  totalOfRemainingTimeInProject: 0,
  totalOfTimesSpentInProject: 0,
  totalSumOfTimeAllocatedOnTheProject: 0,
  trackingAcquiredValue: 0,
  trackingRealCost: 0,
  totalNumberOfProjectsInZone: 0,
};

export type { ZoneIndicators };

export { zoneIndicators };
